import Entity from "../../../class/abstract/Entity";

class News extends Entity {
	title = null;
	link = null;
	created_by = null;

	constructor(datas = {}) {
		super(datas)
		this.setAttributes(datas)
	}

	setAttributes(datas) {
		let keys = Object.keys(this);
		let key = "";

		for(let i in keys) {
			key = keys[i];

			if (datas[key] !== undefined) {
				// except keys
				let exceptKeys = [];

				if (!exceptKeys.includes(key))
					Reflect.set(this, key, datas[key]);
			}
		}
	}
}

export default News;
